// Angular modules
import { HttpClient }    from '@angular/common/http';
import { HttpHeaders }   from '@angular/common/http';
import { Injectable }    from '@angular/core';

// Ionic modules
import { Platform }      from 'ionic-angular';

// External modules
import { DataService }   from './data-service';
import { Observable }    from 'rxjs/Rx';
import 'rxjs/add/operator/map'                          ;

// Internal modules
import { environment }   from '../../../environments/environment';

// Helpers
import { StorageHelper } from '../helpers/storage.helper';
import { User } from '../interfaces/user.interface';

@Injectable()
export class AuthService
{
  constructor(
    private readonly http              : HttpClient,
    private readonly platform          : Platform,
    private readonly dataService       : DataService)
  {}

  createAccount(login, resetPassUrl)
  {
    let body       = {"Email": login, "ResetPassUrl": resetPassUrl}
    let headers    = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept' : 'application/json', 'apiKey' : environment.API_KEY });
    let options    = { headers: headers };

    return this.http.post(environment.API_ENDPOINT+ '/login/create', body, options)
      .catch((error:any) => Observable.throw(error || 'Server error'));
  }

  googleServerAuth(authorizationCode)
  {
    let platform;

    if(this.platform.is('android'))
      platform = "android";
    else if(this.platform.is('ios'))
      platform = "ios";
    else
      platform = null;

    let body    = {"AuthorizationCode": authorizationCode, "IsAutoLogOutEnabled": true, "Platform": platform};
    let headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept' : 'application/json', 'apiKey' : environment.API_KEY });
    let options = { headers: headers, withCredentials: true };

    return this.http.post(environment.API_ENDPOINT+ '/login/google', body, options)
          .catch((error:any) => Observable.throw(error.error.Message || 'Server error'));
  }

  stdServerAuth(login : string, password: string)
  {
    let body       = {"UserName": login, "Password": password, "EncryptionLevel": 0, "IsAutoLogOutEnabled": true}
    let headers    = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept' : 'application/json', 'apiKey' : environment.API_KEY });
    let options    = { headers: headers };

    return this.http.post(environment.API_ENDPOINT+ '/login', body, options)
             .catch((error:any) => Observable.throw(error.error.Message || 'Server error'));
  }

  public async checkAuthValidity(): Promise<'offline'|'no user'|'invalid'|'valid'>
  {
    const isOnline = await this.dataService.isServerAvailable();

    // NOTE Handle online auth behavior
    if(isOnline)
    {
      const localUser = StorageHelper.getUser();
      if(localUser == null || localUser.userId == null)
        return 'no user';

      let user: User|null;
      try
      {
        user = await this.dataService.getUserData();
      }
      catch(e)
      {
        return 'invalid';
      }

      if(user == null)
        return 'invalid'
      else
        return 'valid'
    }

    // NOTE handle offline auth behavior
    if(StorageHelper.getUser() == null)
      return 'invalid'
    else
      return 'offline'
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/providers/auth-service.ts